$(document).ready(function () {
  //finish newsleetter
  document.querySelector("#footer").style.display = "none";

  // second atc button
  document
    .getElementById("AddToCartWithPolering")
    .addEventListener("click", function () {
      $("#AddToCartSticky").click();
      $("#AddToCartStickyPolering").click();
    });
  document
    .getElementById("AddToCartWithPolering2")
    .addEventListener("click", function () {
      $("#AddToCartSticky2").click();
      $("#AddToCartStickyPolering2").click();
    });
  function setupCollapsible(headerId, contentId, arrowId) {
    let isAnimating = false;

    $(document).on("click", headerId, function () {
      if (!isAnimating) {
        isAnimating = true;

        [
          "#pf-1-collapsible-content",
          "#pf-2-collapsible-content",
          "#pf-3-collapsible-content",
          "#pf-4-collapsible-content",
        ].forEach(function (id) {
          if ($(id).is(":visible") && id !== contentId) {
            $(id).slideUp(300);
            const otherArrowId = id.replace("content", "arrow");
            $(otherArrowId).removeClass("rotate-180");
          }
        });

        // if the clicked is #product-collapsible-header-sticky then hide #product-collapsible-header-sticky
        $(contentId).slideToggle({
          duration: 300,
          complete: function () {
            isAnimating = false;
          },
        });
        $(arrowId).toggleClass("rotate-180");
      }
    });
  }

  function setupCollapsibleSticky(headerId, contentId, arrowId) {
    let isAnimating = false;

    $(document).on("click", headerId, function () {
      if (!isAnimating) {
        isAnimating = true;
        if ($(contentId).is(":visible")) {
          $(contentId).fadeOut({
            duration: 300,
            complete: function () {
              isAnimating = false;
            },
          });
        } else {
          $(contentId).fadeIn({
            duration: 300,
            complete: function () {
              isAnimating = false;
            },
          });
        }
        $(arrowId).toggleClass("rotate-0");
      }
    });
  }

  setupCollapsible(
    "#pf-1-collapsible-header",
    "#pf-1-collapsible-content",
    "#pf-1-collapsible-arrow"
  );
  setupCollapsible(
    "#pf-2-collapsible-header",
    "#pf-2-collapsible-content",
    "#pf-2-collapsible-arrow"
  );
  setupCollapsible(
    "#pf-3-collapsible-header",
    "#pf-3-collapsible-content",
    "#pf-3-collapsible-arrow"
  );
  setupCollapsible(
    "#pf-4-collapsible-header",
    "#pf-4-collapsible-content",
    "#pf-4-collapsible-arrow"
  );
  setupCollapsible(
    "#product-collapsible-header",
    "#product-collapsible-content",
    "#product-collapsible-arrow"
  );
  setupCollapsibleSticky(
    "#product-collapsible-header-sticky",
    "#product-collapsible-content-sticky",
    "#product-collapsible-arrow-sticky"
  );
  let isAnimating = false;

  if (!isAnimating) {
    isAnimating = true;
    $("#pf-collapsible-content").slideToggle({
      duration: 300,
      complete: function () {
        isAnimating = false;
      },
    });
    $("#pf-collapsible-arrow").toggleClass("rotate-180");
  }

  $(document).on("click", "#pf-collapsible-header", function () {
    if (!isAnimating) {
      isAnimating = true;
      $("#pf-collapsible-content").slideToggle({
        duration: 300,
        complete: function () {
          isAnimating = false;
        },
      });
      $("#pf-collapsible-arrow").toggleClass("rotate-180");
    }
  });
  function updateMainImage(index) {
    var images = $(".product--thumbnail img");
    if (index >= 0 && index < images.length) {
      var newSrc = images.eq(index).attr("src");
      $("#main-image").attr("src", newSrc);
      $("#image-index").text(index + 1 + " - " + images.length);
    }
  }

  $(document).on("click", ".product--thumbnail img", function () {
    var index = $(".product--thumbnail img").index(this);
    updateMainImage(index);
  });

  $("#image-arrow-prev").on("click", function () {
    var currentIndex = $(".product--thumbnail img").index(
      $('.product--thumbnail img[src="' + $("#main-image").attr("src") + '"]')
    );
    var newIndex =
      (currentIndex - 1 + $(".product--thumbnail img").length) %
      $(".product--thumbnail img").length;
    updateMainImage(newIndex);
  });

  $("#image-arrow-next").on("click", function () {
    var currentIndex = $(".product--thumbnail img").index(
      $('.product--thumbnail img[src="' + $("#main-image").attr("src") + '"]')
    );
    var newIndex = (currentIndex + 1) % $(".product--thumbnail img").length;
    updateMainImage(newIndex);
  });

  $("#image-index").text("1" + " - " + $(".product--thumbnail img").length);


  const tabs = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) =>
        t.classList.remove("text-[#45705b]", "border-b-2", "border-b-[#45705b]")
      );
      tabs.forEach((t) =>
        t.classList.add("border-b", "border-solid", "border-gray-300")
      );
      tab.classList.add("text-[#45705b]", "border-b-2", "border-b-[#45705b]");

      const target = tab.getAttribute("data-tab");
      tabContents.forEach((tc) => tc.classList.remove("active"));
      document.getElementById(target).classList.add("active");
    });
  });
});

tailwind.config = {
  mode: "jit",
  theme: {
    fontFamily: {
      ZapfHumnst: ["ZapfHumnstBT", "sans-serif"],
      Neuton: ["Neuton", "serif"],
    },
    extend: {
      colors: {
        brand: {
          "green-new-10": "#2D503F",
          "light-green-100": "#EEF4D6CC",
          "yellow-100": "#FADA2D99",
          "light-blue-100": "#DFF9FF99",
          "grey-100": "#49565A",
          "light-pink": "#FFCFE9CC",
          "slate-blue-100": "#30393C",
          "grey-200": "#EFEDE7",
        },
      },
    },
  },
};
